export default Object.freeze({
  0: 'Net 10',
  1: 'Net 15',
  2: 'Net 30',
  3: 'Net 45',
  5: 'Net 7',
  6: 'Net 20'
});
